import axios from "axios";
import React, { useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
import Swal from "sweetalert2";
// import MapForPosts from "./MapForPosts";
export function EditPost(): JSX.Element {
  // const backgroundImageStyle = {
  //     backgroundImage: "url('https://images.unsplash.com/photo-1586075010923-2dd4570fb338?q=80&w=387&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D 387w, https://images.unsplash.com/photo-1586075010923-2dd4570fb338?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D 687w, https://images.unsplash.com/photo-1586075010923-2dd4570fb338?q=80&w=774&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D 774w, https://images.unsplash.com/photo-1586075010923-2dd4570fb338?q=80&w=987&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D 987w, https://images.unsplash.com/photo-1586075010923-2dd4570fb338?q=80&w=1287&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D 1287w, https://images.unsplash.com/photo-1586075010923-2dd4570fb338?q=80&w=1374&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D 1374w, https://images.unsplash.com/photo-1586075010923-2dd4570fb338?q=80&w=1587&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D 1587w, https://images.unsplash.com/photo-1586075010923-2dd4570fb338?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D 1887w, https://images.unsplash.com/photo-1586075010923-2dd4570fb338?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D 1974w, https://images.unsplash.com/photo-1586075010923-2dd4570fb338?q=80&w=2187&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D 2187w, https://images.unsplash.com/photo-1586075010923-2dd4570fb338?q=80&w=2487&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D 2487w, https://images.unsplash.com/photo-1586075010923-2dd4570fb338?q=80&w=2574&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D 2574w, https://images.unsplash.com/photo-1586075010923-2dd4570fb338?q=80&w=2787&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D 2787w, https://images.unsplash.com/photo-1586075010923-2dd4570fb338?q=80&w=3087&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D 3087w, https://images.unsplash.com/photo-1586075010923-2dd4570fb338?q=80&w=3174&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D 3174w, https://images.unsplash.com/photo-1586075010923-2dd4570fb338?q=80&w=3387&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D 3387w, https://images.unsplash.com/photo-1586075010923-2dd4570fb338?q=80&w=3687&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D 3687w, https://images.unsplash.com/photo-1586075010923-2dd4570fb338?q=80&w=3760&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D 3760w')",
  //     backgroundSize: 'cover',
  //     backgroundRepeat: 'no-repeat',
  //     backgroundPosition: 'center',
  // };

  useEffect(() => {
    getDetailAssetBeforeUpdated();
  }, []);

  interface FormData {
    images: File[];
    front_deeds: File[];
    back_deeds: File[];
    youtube_url: string;
    vr_url: string;
    heading_post: string;
    detail_post: string;
    type_post: string[];
    floor_variable: string;
    [key: string]: string | File[] | string[];
    area: string;
    unit_area: string;
    use_area: string;
    use_unit_area: string;
    bedroom: string;
    bathroom: string;
    price: string;
    rent_price_: string;
    sellOut_price: string;
    owner_status: string;
    first_hand: string;
    furniture_included: string;
    phone_number: string;
    line_id: string;
    asset_location_latitude: string; //not use  , use sessionStorage
    asset_location_longitude: string; //not use  , use sessionStorage
  }

  interface PropertyMap {
    [key: string]: {
      [key: string]: string | number;
    };
  }

  const initialFormData: FormData = {
    images: [],
    front_deeds: [],
    back_deeds: [],
    youtube_url: "",
    vr_url: "",
    heading_post: "",
    detail_post: "",
    type_post: [],
    // floor_variable
    floor_variable: "",
    area: "",
    unit_area: "",
    use_area: "",
    use_unit_area: "",
    bedroom: "",
    bathroom: "",
    price: "",
    rent_price_: "",
    sellOut_price: "",
    owner_status: "",
    first_hand: "",
    furniture_included: "",
    phone_number: "",
    line_id: "",
    asset_location_latitude: "", //not use  , use sessionStorage
    asset_location_longitude: "", // not use , use sessionStorage
  };
  const token = localStorage.getItem(`token`);
  const initTypeOfForm = sessionStorage.getItem("typeOfAsset");
  const [typeOfForm, setTypeOfForm] = useState<any>(initTypeOfForm); // commercialBuilding
  const [dataUpload, setDataUpload] = useState<FormData>(initialFormData);
  const [oldDataBeforeEdit, setOldDataBeforeEdit] = useState<any>(null);
  const [thumbnailMain, setThumbnailMain] = useState<string | null>(null);
  const [thumbnailMainIndex, setThumbnaiMainlIndex] = useState<number | null>(
    null
  );

  const [thumbnailLeft, setThumbnailLeft] = useState<string | null>(null);
  const [thumbnailRight, setThumbnailRight] = useState<string | null>(null);
  const lead_id = sessionStorage.getItem("lead_id_posts");
  const lead_uname = sessionStorage.getItem("leadUname_post");
  const lead_uid_for_help_post = sessionStorage.getItem("lead_uid_help_post");

  function uploadDataAssetToServer(): void {
    try {
      const propertyMap: PropertyMap = {
        house: {
          floor_house: dataUpload.floor_variable,
          bedrooms_house: dataUpload.bedroom,
          bathrooms_house: dataUpload.bathroom,
        },
        townhouse: {
          floor_townhouse: dataUpload.floor_variable,
          bathrooms_townhouse: dataUpload.bedroom,
          bedrooms_townhouse: dataUpload.bathroom,
        },
        condo: {
          floor_condo: dataUpload.floor_variable,
          bedrooms_condo: dataUpload.bedroom,
          bathrooms_condo: dataUpload.bathroom,
          // building : "some value building",
        },
        commercial: {
          floor_commercial: dataUpload.floor_variable,
          bathrooms_commercial_building: dataUpload.bathroom,
          bedrooms_commercial_building: dataUpload.bedroom,
        },
        land: {
          rai: 1,
          ngan: 2,
          wah: 3,
        },
      };

      const formData = {
        images: dataUpload.images,
        frontdeeds: dataUpload.front_deeds,
        backdeeds: dataUpload.back_deeds,
        youtube_url: dataUpload.youtube_url,
        vr_url: dataUpload.vr_url,
        heading_post: dataUpload.heading_post,
        detail_post: dataUpload.detail_post,
        type_post: dataUpload.type_post,
        sell_price: dataUpload.price.replaceAll(",", ""),
        rent_price: dataUpload.rent_price_.replaceAll(",", ""),
        sellOut_price: dataUpload.sellOut_price.replaceAll(",", ""),
        ...propertyMap[typeOfForm], // Include properties based on typeOfForm
        total_size: dataUpload.area,
        total_unit: dataUpload.unit_area,
        living_size: dataUpload.use_area,
        living_unit: dataUpload.use_unit_area,
        owner_status: dataUpload.owner_status,
        first_hand: dataUpload.first_hand,
        furniture_included: dataUpload.furniture_included,
        phone_number: dataUpload.phone_number,
        line_id: dataUpload.line_id,
        asset_location_latitude: sessionStorage.getItem("LatForPost"),
        asset_location_longitude: sessionStorage.getItem("LngForPost"),
        lead_id: lead_id,
        lead_uname: lead_uname,
        lead_uid_for_help_post: lead_uid_for_help_post, // use for help posts postperty only (คนชวนได้เงินแทน) // not using
      };

      axios
        .post(
          `${process.env.REACT_APP_ADMIN_API}/post/${typeOfForm}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          console.log(res.data);
          const statusOK = res.data.Success;
          if (statusOK) {
            Swal.fire(`${statusOK}`, "", "success");
            // window.location.replace("/lead")
          }
        })
        .catch((err) => {
          console.log(`debug error`, err);
          Swal.fire(`${err.response.data.Error}`, "", "error");
          // Swal.fire(`${err.response}`, '' , "error");
        });
    } catch (error) {
      console.error(error);
    }
  }

  function getDetailAssetBeforeUpdated(): void {
    axios
      .get(
        `${process.env.REACT_APP_ADMIN_API}/fetchData/search-asset/BK-BK-230901-6NJNL`
      )
      .then((res) => {
        console.log(res.data?.asset);
        setOldDataBeforeEdit(res.data.asset);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function inputValue(
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    key: string
  ): void {
    const value = e.target.value;

    switch (key) {
      case "youtube_url":
        const isValidate = validateYouTubeUrl(value);
        console.log(isValidate);
        break;
      default:
        break;
        console.log("default");
    }

    const message = validateYouTubeUrl("");
    console.log(message);
    setDataUpload((prevData) => ({ ...prevData, [key]: value }));
  }

  function handleTextareaInput(
    e: React.ChangeEvent<HTMLTextAreaElement>
  ): void {
    const lengthOfHeading = e.target.value.length;
    let wordOfHeading = e.target.value;

    if (lengthOfHeading > 1800) {
      wordOfHeading = wordOfHeading.substring(0, 1800);
      setDataUpload((prevData) => ({
        ...prevData,
        detail_post: wordOfHeading,
      }));
    } else {
      setDataUpload((prevData) => ({
        ...prevData,
        detail_post: wordOfHeading,
      }));
    }
  }

  function handleChangeImageMain(e: React.ChangeEvent<HTMLInputElement>) {
    const files = e.target.files;
    if (files) {
      const newImages = Array.from(files);
      // Append the new images to the existing array
      setDataUpload((prevData) => ({
        ...prevData,
        images: [...prevData.images, ...newImages],
      }));

      // Display the thumbnail for the first image
      if (newImages.length > 0) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setThumbnaiMainlIndex(0);
          setThumbnailMain(reader.result as string);
        };
        reader.readAsDataURL(newImages[0]);
      }
    }
  }

  function handleChangeImageThumbLeftRight(
    e: React.ChangeEvent<HTMLInputElement>,
    key: string
  ): void {
    const files = e.target.files;

    if (files) {
      const newImages = Array.from(files);
      setDataUpload({ ...dataUpload, [`${key}_deeds`]: newImages });

      if (newImages.length > 0) {
        const reader = new FileReader();
        reader.onloadend = () => {
          if (key === "front") {
            setThumbnailLeft(reader.result as string);
          } else if (key === "back") {
            setThumbnailRight(reader.result as string);
          }
        };
        reader.readAsDataURL(newImages[0]);
      }
    }
  }

  function handleThumbnailToMainDisplay(image: string) {
    setThumbnailMain(image);
  }

  function inputValueSwitchForm(
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    key: string
  ): void {
    setDataUpload((prevData) => ({
      ...prevData,
      [`floor_${key}`]: e.target.value,
    }));
  }

  async function handleDeleteImage(index: number, imageUrl: string) {
    await setDataUpload((prevData) => {
      const updatedImages = [...prevData.images];
      updatedImages.splice(index, 1);

      const newState = { ...prevData, images: updatedImages };

      // Check image is last image remove thumbnail
      if (newState.images.length === 0) {
        setThumbnailMain(null);
        setThumbnaiMainlIndex(0);
      } else if (index === thumbnailMainIndex) {
        // set NewThumbnail if remove index 0 or thumbnail because thumbnail is initial is index 0 && setIndexThumbnail is 0
        const newThumbnail = URL.createObjectURL(updatedImages[0]);
        setThumbnailMain(newThumbnail);
        setThumbnaiMainlIndex(0);
      }
      return newState;
    });
  }

  function handleRemoveThumanilLeftRight(key: string): void {
    // check key if key is left setThumnail left other setThumnailRight
    const thumbnailSetter =
      key === "front" ? setThumbnailLeft : setThumbnailRight;
    thumbnailSetter("");
    setDataUpload({ ...dataUpload, [`${key}_deeds`]: [] });
  }

  function handleCheckbox(keyword: string) {
    console.log(keyword);

    //  Check if keyword (ขาย,เช่า,เซ้ง) has in type_post [] after clicked 2 time
    if (dataUpload.type_post.includes(keyword)) {
      const newTypePost = dataUpload.type_post.filter((key) => key !== keyword);
      setDataUpload({ ...dataUpload, type_post: newTypePost });
    } else {
      setDataUpload({
        ...dataUpload,
        type_post: [...dataUpload.type_post, keyword],
      });
    }
  }

  function handleUnitArea(unit: string) {
    console.log(unit);
    setDataUpload({ ...dataUpload, unit_area: unit });
  }

  function handleUseUnitArea(unit: string) {
    console.log(unit);
    setDataUpload({ ...dataUpload, use_unit_area: unit });
  }

  function handleBedRoom(e: any) {
    const amount = e.target.value;
    setDataUpload({ ...dataUpload, bedroom: amount });
  }

  function handleBathRoom(e: any) {
    const amount = e.target.value;
    setDataUpload({ ...dataUpload, bathroom: amount });
  }

  function formatNumberWithCommas(value: any) {
    if (typeof value === "string") {
      // Remove commas from the value if it already has them
      value = value.replace(/,/g, "");
    }

    // Parse the value as a number
    const numberValue = parseFloat(value);

    // Check if the parsed value is a valid number
    if (!isNaN(numberValue)) {
      // Format the number with commas
      return numberValue.toLocaleString();
    }

    // Return the original value if it couldn't be formatted
    return value;
  }

  const inputValuePrice = (name: string) => (e: any) => {
    let value = e.target.value;

    if (name === "price" && value !== "") {
      value = value.replace(/,/g, ""); // Remove existing commas
      value = formatNumberWithCommas(value); // Format the value with commas
    } else if (name === "rent_price_" && value !== "") {
      value = value.replace(/,/g, ""); // Remove existing commas
      value = formatNumberWithCommas(value); // Format the value with commas
    } else if (name === "sellOut_price" && value !== "") {
      value = value.replace(/,/g, ""); // Remove existing commas
      value = formatNumberWithCommas(value); // Format the value with commas
    }

    setDataUpload({ ...dataUpload, [name]: value });
  };

  function handleOwnerStatus(status: string) {
    setDataUpload({ ...dataUpload, owner_status: status });
  }

  const handleFurniture = (status: string) => {
    setDataUpload({ ...dataUpload, furniture_included: status });
  };

  function handleFirstHand(status: string) {
    setDataUpload({ ...dataUpload, first_hand: status });
  }

  interface FormTypeMap {
    [key: string]: string;
  }
  const formTypeMap: FormTypeMap = {
    house: "บ้าน",
    condo: "คอนโด",
    townhouse: "ทาวน์เฮ้าส์",
    commercial: "อาคารพาณิชย์",
    land: "ที่ดิน",
  };

  // Validate Section
  function validateYouTubeUrl(url: string) {
    // Regular expression to match YouTube URL
    const regExp = /^(https?\:\/\/)?(www\.youtube\.com|youtu\.?be)\/.+$/;
    return regExp.test(url);
  }
  // Validate Section

  if (!oldDataBeforeEdit) {
    // Return a loading state or spinner while waiting for data
    return <div>Loading...</div>;
  }

  return (
    <main className="w-full h-screen ">
      <form>
        <div className=" h-[999px] mt-16 overflow-y-auto ">
          {/* <span className="text-xl font-bold">ระบุตำแหน่งอสังหาฯ</span> */}
          {/* <MapForPosts /> */}

          <div className="w-full mx-auto   flex  flex-col items-center md:w-9/12">
            <div className="w-11/12 flex flex-col ">
              {/* <h1>1.อัพโหลดรูปภาพ</h1> */}
              <div className="relative w-full h-[400px] bg-gray-100 rounded-xl cursor-pointer mt-2.5">
                <input
                  type="file"
                  name="images"
                  className="w-full h-full border z-50 absolute top-0 left-0 opacity-0 cursor-pointer"
                  accept="image/png, image/jpeg, image/jpg"
                  onChange={(e) => handleChangeImageMain(e)}
                  multiple
                />
                <h1 className="font-main absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 ">{`ใส่รูปภาพ`}</h1>

                {thumbnailMain && (
                  <img
                    src={thumbnailMain}
                    alt="thumbnail-image"
                    className="w-full h-full absolute top-0 rounded-xl object-contain  z-0" // Adjusted z-index
                  />
                )}
              </div>

              <div
                className={
                  dataUpload.images.length > 0
                    ? "w-11/12 h-[100px] overflow-x-auto border flex rounded-xl mt-2.5 "
                    : "hidden"
                }
              >
                {dataUpload.images.map((image, index) => {
                  const convertFileToImageURL = URL.createObjectURL(image);
                  return (
                    <div
                      key={index}
                      className="relative flex-shrink-0 cursor-pointer"
                    >
                      <img
                        className="h-full ml-[2px]"
                        src={convertFileToImageURL}
                        onClick={() =>
                          handleThumbnailToMainDisplay(convertFileToImageURL)
                        }
                        alt={`thumbnail-${index}`}
                      />

                      <IoMdClose
                        className="absolute right-2 top-2 bg-white rounded-full w-5 h-5"
                        onClick={() =>
                          handleDeleteImage(index, convertFileToImageURL)
                        }
                      />
                    </div>
                  );
                })}
              </div>

              <div className="w-full grid grid-cols-12 gap-x-2.5 mt-2.5 h-auto">
                <div className="col-span-6 relative w-full h-[250px] bg-gray-100 rounded-xl">
                  <input
                    type="file"
                    name="images"
                    className="w-full h-full border z-50 absolute top-0 left-0 opacity-0 cursor-pointer"
                    accept="image/png, image/jpeg, image/jpg"
                    onChange={(e) =>
                      handleChangeImageThumbLeftRight(e, "front")
                    }
                  />

                  {thumbnailLeft && (
                    <div className="relative w-full h-full">
                      <img
                        src={thumbnailLeft}
                        alt="thumbnailLeft-image"
                        className=" w-full h-full absolute top-0 rounded-xl object-contain  z-0  " // Adjusted z-index
                      />
                      <IoMdClose
                        className="absolute right-2 top-2 bg-black text-white cursor-pointer z-50 rounded-full w-5 h-5"
                        onClick={() => handleRemoveThumanilLeftRight("front")}
                      />
                    </div>
                  )}

                  <h1
                    className={
                      thumbnailLeft
                        ? "hidden"
                        : "font-main absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full text-center "
                    }
                  >{`โฉนดด้านหน้า`}</h1>
                </div>

                <div className="col-span-6 relative w-full h-[250px] bg-gray-100 rounded-xl cursor-pointer">
                  <input
                    type="file"
                    name="images"
                    className="w-full h-full border z-50 absolute top-0 left-0 opacity-0 cursor-pointer"
                    accept="image/png, image/jpeg, image/jpg"
                    onChange={(e) => handleChangeImageThumbLeftRight(e, "back")}
                  />

                  {thumbnailRight && (
                    <div className="relative w-full h-full ">
                      <img
                        src={thumbnailRight}
                        alt="thumbnailRight-image"
                        className=" w-full h-full absolute top-0 rounded-xl object-contain  z-0  " // Adjusted z-index
                      />
                      <IoMdClose
                        className="absolute right-2 top-2 bg-black text-white cursor-pointer z-50 rounded-full w-5 h-5"
                        onClick={() => handleRemoveThumanilLeftRight("back")}
                      />
                    </div>
                  )}

                  <h1
                    className={
                      thumbnailRight
                        ? "hidden"
                        : "font-main absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full text-center "
                    }
                  >{`โฉนดด้านหน้า`}</h1>
                </div>
              </div>
            </div>

            <div className="w-11/12 h-[1800px]   mt-2.5  mx-auto">
              <input
                type="text"
                defaultValue={oldDataBeforeEdit?.media?.YoutubeURL}
                placeholder="YouTube URL"
                className="h-12 w-full bg-gray-100  rounded-xl outline-0 text-center"
                onChange={(e) => inputValue(e, "youtube_url")}
              />
              <input
                type="text"
                defaultValue={oldDataBeforeEdit?.media?.vr_url}
                placeholder="VR URL ที่รองรับ MatterPort , Cloudpano , Kuula , Pano360"
                className="h-12 w-full bg-gray-100  rounded-xl outline-0 text-center mt-2"
                onChange={(e) => inputValue(e, "vr_url")}
              />
              <input
                type="text"
                defaultValue={oldDataBeforeEdit?.title}
                placeholder="หัวข้อประกาศ"
                className="h-12 w-full bg-gray-100  rounded-xl outline-0 text-center mt-2"
                onChange={(e) => inputValue(e, "heading_post")}
              />
              <div className="w-full h-auto  mt-2.5">
                <h3 className="">{`รายละเอียดประกาศ ${
                  dataUpload.detail_post.length ||
                  oldDataBeforeEdit?.description.length ||
                  0
                }/1800*`}</h3>
                <textarea
                  defaultValue={oldDataBeforeEdit?.description}
                  value={dataUpload.detail_post}
                  className="w-full h-[500px] bg-gray-100 rounded-xl mt-2.5 outline-0 p-2"
                  onChange={handleTextareaInput}
                />
              </div>

              {/* <div className="hidden flex justify-around items-center bg-gray-100 mt-2.5 w-full h-12 rounded-xl "> */}
              {/* <Checkbox label="ขาย"  /> */}
              {/* <div className="flex justify-center items-center">
                  <input
                defaultValue={oldDataBeforeEdit?.sell_price}
                  
                    onChange={() => handleCheckbox("ขาย")}
                    type="checkbox"
                    value=""
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  />
                  <label className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                    ขาย
                  </label>
                </div> */}

              {/* <div className="flex justify-center items-center">
                  <input
                    defaultValue={oldDataBeforeEdit?.rent_price}
                    onChange={() => handleCheckbox("เช่า")}
                    type="checkbox"
                    value=""
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  />
                  <label className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                    เช่า
                  </label>
                </div> */}

              {/* <div className="flex justify-center items-center">
                  <input
                    onChange={() => handleCheckbox("เซ้ง")}
                    type="checkbox"
                    value=""
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  />
                  <label className="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                    เซ้ง
                  </label>
                </div> */}
              {/* </div> */}

              <div className="w-full h-auto ">
                {/* <div className="w-full h-full mt-2.5">
                  <span>{`ราคาขาย`}</span>
                  <input
                    defaultValue={dataUpload?.price}
                    type="text"
                    placeholder={`ราคาขาย`}
                    className="h-12 w-full bg-gray-100  rounded-full outline-0 text-center mt-2"
                    onChange={inputValuePrice(`price`)}
                    value={dataUpload.price}
                  />
                </div>

                <div className="w-full h-full mt-2.5">
                  <span>{`ราคาเช่า`}</span>
                  <input
                    defaultValue={dataUpload.rent_price_}
                    type="text"
                    placeholder={`ราคาเช่า`}
                    className="h-12 w-full bg-gray-100  rounded-full outline-0 text-center mt-2"
                    onChange={inputValuePrice(`rent_price_`)}
                    value={dataUpload.rent_price_}
                  />
                </div>

                <div className="w-full h-full mt-2.5">
                  <span>{`ราคาเซ้ง`}</span>
                  <input
                    defaultValue={dataUpload.sellOut_price}
                    type="text"
                    placeholder={`ราคาเซ้ง`}
                    className="h-12 w-full bg-gray-100  rounded-full outline-0 text-center mt-2"
                    onChange={inputValuePrice(`sellOut_price`)}
                    value={dataUpload.sellOut_price}
                  />
                </div> */}

                {/* <div className={typeOfForm === "land" ? "hidden" : "w-full h-full mt-2.5"}>
                  <span>{`จำนวนชั้นของ${formTypeMap[typeOfForm]}`}</span>
                  <input
                    type="number"
                    step={1}
                    placeholder={`จำนวนชั้นของ${formTypeMap[typeOfForm]}`}
                    className="h-12 w-full bg-gray-100  rounded-full outline-0 text-center mt-2"
                    onChange={(e) =>
                      inputValue(e, "floor_variable")
                    }
                  />
                </div> */}

                <div className="w-full h-full mt-2.5">
                  <span>{`ขนาดพื้นที่`}</span>
                  <input
                    defaultValue={oldDataBeforeEdit?.land?.total_size}
                    type="number"
                    step={1}
                    placeholder={`ขนาดพื้นที่`}
                    className="h-12 w-full bg-gray-100  rounded-full outline-0 text-center mt-2"
                    onChange={(e) => inputValue(e, `area`)}
                  />
                </div>

                <div className="grid grid-cols-2 w-full h-full mt-2.5">
                  <div
                    className={` w-full h-12 rounded-full flex justify-center items-center cursor-pointer ${
                      dataUpload.unit_area === "ตารางเมตร" ||
                      oldDataBeforeEdit?.land?.total_unit === "ตารางเมตร"
                        ? "bg-postperty text-white"
                        : "bg-gray-100"
                    }`}
                    onClick={() => handleUnitArea("ตารางเมตร")}
                  >
                    ตารางเมตร
                  </div>
                  <div
                    className={` w-full h-12 rounded-full flex justify-center items-center cursor-pointer ${
                      dataUpload.unit_area === "ตารางวา" ||
                      oldDataBeforeEdit?.land?.total_unit === "ตารางวา"
                        ? "bg-postperty text-white"
                        : "bg-gray-100"
                    }`}
                    onClick={() => handleUnitArea("ตารางวา")}
                  >
                    ตารางวา
                  </div>
                </div>

                <div className="w-full h-full mt-2.5">
                  <span>{`ขนาดพื้นที่ใช้สอย`}</span>
                  <input
                    defaultValue={oldDataBeforeEdit?.land?.living_size}
                    type="number"
                    step={1}
                    placeholder={`ขนาดพื้นที่ใช้สอย`}
                    className="h-12 w-full bg-gray-100  rounded-full outline-0 text-center mt-2"
                    onChange={(e) => inputValue(e, `use_area`)}
                  />
                </div>

                <div className="grid grid-cols-2 w-full h-full mt-2.5">
                  <div
                    className={` w-full h-12 rounded-full flex justify-center items-center  cursor-pointer ${
                      dataUpload.unit_area === "ตารางเมตร" ||
                      oldDataBeforeEdit?.land?.living_unit === "ตารางเมตร"
                        ? "bg-postperty text-white"
                        : "bg-gray-100"
                    }`}
                    onClick={() => handleUseUnitArea("ตารางเมตร")}
                  >
                    ตารางเมตร
                  </div>
                  <div
                    className={` w-full h-12 rounded-full flex justify-center items-center cursor-pointer ${
                      dataUpload.unit_area === "ตารางวา" ||
                      oldDataBeforeEdit?.land?.living_unit === "ตารางวา"
                        ? "bg-postperty text-white"
                        : "bg-gray-100"
                    }`}
                    onClick={() => handleUseUnitArea("ตารางวา")}
                  >
                    ตารางวา
                  </div>
                </div>

                <div className="w-full mt-2.5">
                  <select
                    onChange={handleBedRoom}
                    value={oldDataBeforeEdit?.rooms?.Bedroom || ""}
                    className="w-full h-12 bg-gray-100 rounded-full text-center outline-0"
                  >
                    <option key={0} value="">
                      เลือกจำนวนห้องนอน
                    </option>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
                      <option key={num} value={num}>
                        {`${num} ห้องนอน`}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="w-full mt-2.5">
                <select
                    onChange={handleBathRoom}
                    value={oldDataBeforeEdit?.rooms?.Bedroom || ""}
                    className="w-full h-12 bg-gray-100 rounded-full text-center outline-0"
                  >
                    <option key={0} value="">
                      เลือกจำนวนห้องน้ำ
                    </option>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
                      <option key={num} value={num}>
                        {`${num} ห้องน้ำ`}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="grid grid-cols-2 w-full h-full mt-2.5">
                  <span className="col-span-12">สถานะผู้ขาย</span>
                  <div
                    className={` w-full h-12 rounded-full flex justify-center items-center cursor-pointer ${
                      dataUpload.owner_status === "owner"
                        ? "bg-postperty text-white"
                        : "bg-gray-100"
                    }`}
                    onClick={() => handleOwnerStatus("owner")}
                  >
                    เจ้าของขายเอง
                  </div>
                  <div
                    className={` w-full h-12 rounded-full flex justify-center items-center cursor-pointer ${
                      dataUpload.owner_status === "agent"
                        ? "bg-postperty text-white"
                        : "bg-gray-100"
                    }`}
                    onClick={() => handleOwnerStatus("agent")}
                  >
                    ตัวแทนขาย
                  </div>
                </div>

                <div className="grid grid-cols-2 w-full h-full mt-2.5">
                  <span className="col-span-12">{`สถานะ${formTypeMap[typeOfForm]}`}</span>
                  <div
                    className={` w-full h-12 rounded-full flex justify-center items-center cursor-pointer ${
                      dataUpload.first_hand === "true"
                        ? "bg-postperty text-white"
                        : "bg-gray-100"
                    }`}
                    onClick={() => handleFirstHand("true")}
                  >
                    มือหนึ่ง
                  </div>
                  <div
                    className={` w-full h-12 rounded-full flex justify-center items-center cursor-pointer ${
                      dataUpload.first_hand === "false"
                        ? "bg-postperty text-white"
                        : "bg-gray-100"
                    }`}
                    onClick={() => handleFirstHand("false")}
                  >
                    มือสอง
                  </div>
                </div>

                <div className="grid grid-cols-2 w-full h-full mt-2.5">
                  <span className="col-span-12">{`เฟอร์นิเจอร์`}</span>
                  <div
                    className={` w-full h-12 rounded-full flex justify-center items-center cursor-pointer ${
                      dataUpload.furniture_included === "true"
                        ? "bg-postperty text-white"
                        : "bg-gray-100"
                    }`}
                    onClick={() => handleFurniture("true")}
                  >
                    มี
                  </div>
                  <div
                    className={` w-full h-12 rounded-full flex justify-center items-center cursor-pointer ${
                      dataUpload.furniture_included === "false"
                        ? "bg-postperty text-white"
                        : "bg-gray-100"
                    }`}
                    onClick={() => handleFurniture("false")}
                  >
                    ไม่มี
                  </div>
                </div>

                <div className="w-full h-full mt-2.5">
                  <span>{`เบอร์โทรศัพท์`}</span>
                  <input
                    type="text"
                    placeholder={`080191xxxx`}
                    className="h-12 w-full bg-gray-100  rounded-full outline-0 text-center mt-2"
                    onChange={(e) => inputValue(e, `phone_number`)}
                  />
                </div>

                <div className="w-full h-full mt-2.5">
                  <span>{`Line ID`}</span>
                  <input
                    type="text"
                    placeholder={`ไอดีไลน์`}
                    className="h-12 w-full bg-gray-100  rounded-full outline-0 text-center mt-2"
                    onChange={(e) => inputValue(e, `line_id`)}
                  />
                </div>

                <div
                  className="w-full h-12 bg-postperty text-white rounded-full mt-2.5 flex justify-center items-center"
                  onClick={() => uploadDataAssetToServer()}
                >
                  อัพโหลดข้อมูล
                </div>

                <div className="grid grid-cols-12 w-full  mt-2.5 h-[300px]"></div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </main>
  );
}
